import React, {useCallback} from 'react';
import styled from 'styled-components';
import {SVGICONS} from '@ey/icons';
import labels from '../../../util/utils';

function TreeIcon(props) {
	const {icon, isOpened, disabled, onClick, className} = props;

	const handleOnIconClick = (evt) => {
		onClick && onClick(evt);
	};

	return (
		<StyledTreeIcon className={`tree-icon${className ? ' ' + className : ''}`} onClick={handleOnIconClick}>
			{icon ? (
				icon
			) : (
				<SVGICONS
					styleName={`medium ${disabled ? 'disabled' : ''}`}
					name={isOpened ? 'minus' : 'plus'}
					hoverText={isOpened ? labels.collapse : labels.expand}
				/>
			)}
		</StyledTreeIcon>
	);
}

const StyledTreeIcon = styled.span`
	display: inline-flex;
	align-items: center;
	margin-right: var(--px-10);
	width: var(--px-20);
	height: var(--px-20);
	svg {
		fill: var(--neutrals-900);
		&.disabled {
			cursor: default;
		}
	}
`;

export default TreeIcon;
